import { generateUUID } from '@/modules/uuid';

const CORRELATION_HEADER = 'x-correlation-id';

const TRACE_VERSION = '00';
const TRACE_FLAGS = '01';

const SPAN_ID_LENGTH = 16;

export interface Correlation {
    correlationId: string;
    traceId: string;
    spanId: string;
    headers: Record<string, string>;
}

// A dashless v4 UUID is 32 lowercase hex and never all zeros, which is the W3C trace-id rule.
function hexId(length: number): string {
    return generateUUID().replace(/-/g, '').slice(0, length);
}

// One id in both headers: the server prefers traceparent and ignores a differing fallback.
export function newCorrelation(): Correlation | undefined {
    let traceId: string;
    let spanId: string;

    try {
        traceId = hexId(32);
        spanId = hexId(SPAN_ID_LENGTH);
    } catch {
        // The caller is on the clinical submit path, which must not fail over a header.
        return undefined;
    }

    return {
        correlationId: traceId,
        traceId,
        spanId,
        headers: {
            traceparent: `${TRACE_VERSION}-${traceId}-${spanId}-${TRACE_FLAGS}`,
            [CORRELATION_HEADER]: traceId,
        },
    };
}
